module.exports = __webpack_public_path__ + "img/MOB.d7b32fd2.svg";